import store from '@/store'
import mutationTypes from '@/store/mutationTypes'

export default {
  async getCustomer() {
    const customers = await store.dispatch('Customer/getCustomersFromApi')

    if (!customers) {
      // API実行失敗
      return {}
    }
    const customerIdNameList = customers.data.map((ele) => {
      return { label: ele.rep, value: ele.customerId }
    })

    // customerIdNameListをグローバル変数に詰める
    store.commit(
      `Customer/${mutationTypes.CUSTOMER_SET_CUSTOMER_ID_NAME_LIST}`,
      customerIdNameList
    )

    return customers
  },
  // getCustomerCategory(code) {
  //   const customerCategory =
  //     store.getters['Common/getCustomerCategoryFromState']
  //   const ret = customerCategory.find((v) => v.id === code)
  //   return ret.category
  // },
  getCustomerNameById(id) {
    return this.getCustomerById(id).organizationName
  },
  getCustomerById(id) {
    const customerList = store.getters['Customer/getCustomerListFromState']
    const ret = customerList.find((v) => v.customerId == id)
    return ret
  },
  async getCustomerIdNameFromState() {
    const customers = await store.dispatch('Customer/getCustomersFromApi')
    // API実行失敗
    if (!customers) {
      return {}
    }
    const customerIdNameList = customers.data.map((ele) => {
      return { label: ele.organizationName, value: ele.customerId }
    })

    return {
      code: customers.code,
      message: customers.message,
      data: customerIdNameList
    }
  }
}
